<template>
  <!-- 参标信息 -->
  <div class="shop-Product">
    <div class="block" v-for="item in listArr" :key="item.id">
      <div class="block-left">
        <div class="show-box">
          <img
            src="../../../../../../assets/imgs/tx1@3x.svg"
            alt=""
          />
          <p class="p">{{ item.name }}</p>
          <p class="p">{{ item.address }}</p>
          <p class="tag-p">{{ item.type }}</p>
          <p
            class="star"
            v-for="(item, index) in item.mark"
            :key="index + 1"
          ></p>
          <p
            class="null"
            v-for="(item, index) in 5 - item.mark"
            :key="index + 10"
          ></p>
        </div>
        <div class="service-type">服务类型：{{ item.serviceType }}</div>
        <div class="service-type">销量：{{ item.SalesVolume }}</div>
      </div>
      <div class="block-right">
        <div :class="item.HitHit ? 'InThe' : 'miss'"></div>
        <p class="firm-clickable" v-if="distinguish==1" @click="handelViewOption(item)">查看报价与方案</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listArr: {},
    distinguish:{}, //区分 在店铺管理中是可以查看报价及方案的在帮帮看别的店铺用到此组件时不能让其查看报价及方案 1可查看  2不可查看
  },
  data() {
    return {
      mark: 4, //评分
      HitHit: false, //中标
    };
  },
  watch: {},
  components: {},
  created() {},
  destroyed() {},
  methods: {
    // 查看报价及方案
    handelViewOption(item) {
      this.$emit("handelViewOption");
    },
  },
};
</script>

<style scoped lang="less">
.shop-Product {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #333333;
  font-weight: 400;
  display: flex;
  flex-wrap: wrap;
  .block {
    width: 540px;
    height: 100px;
    background: #ffffff;
    box-shadow: 0px 0px 5px 0px rgba(125, 125, 125, 0.5);
    border-radius: 15px;
    margin-bottom: 18px;
    margin-left: 18px;
    padding: 10px;
    display: flex;
    .block-left {
      flex: 1;
      height: 100%;
      margin-right: 30px;
      display: flex;
      flex-direction: column;
      .show-box {
        width: 100%;
        height: 30px;
        line-height: 30px;
        display: flex;
        position: relative;
        margin: auto;
        // margin-bottom: 10px;
        // border: 1px solid gold;
        img {
          width: 30px;
          height: 30px;
          margin: auto 0;
        }
        .p {
          font-size: 12px;
          color: #333333;
          margin: 0px 10px 0px 10px;
        }
        .tag-p {
          width: 60px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          margin: auto 0;
          font-size: 10px;
          color: #409eff ;
          background: rgba(97, 144, 232, 0.2);
          border-radius: 5px;
          margin: 5px 10px 5px 10px;
        }
        .star {
          width: 15px;
          height: 14px;
          background-image: url("../../../../../../assets/imgs/shoucang@3x.svg");
          background-size: 100% 100%;
          margin: auto 0;
          margin-right: 2px;
        }
        .null {
          width: 15px;
          height: 14px;
          background-image: url("../../../../../../assets/imgs/shoucang-null@3x.svg");
          background-size: 100% 100%;
          margin: auto 0;
          margin-right: 2px;
        }
      }
      .service-type {
        width: 380px;
        height: 30px;
        line-height: 40px;
        font-size: 12px;
        color: #999999;
        margin: auto;
        text-indent: 40px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        // border: 1px solid gold;
      }
    }
    .block-right {
      width: 120px;
      height: 100%;

      div {
        width: 50px;
        height: 50px;
        margin: 0 auto;
      }
      .InThe {
        background-image: url("../../../../../../assets/imgs/zhongbiao@3x.svg");
        background-size: 100% 100%;
      }
      .miss {
        background-image: url("../../../../../../assets/imgs/weizhongbiao-xiao@3x.svg");
        background-size: 100% 100%;
      }
      p {
        width: 120px;
        height: 30px;
        line-height: 30px;
        background: #409eff ;
        border-radius: 5px;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        margin-top: 10px;
        cursor: pointer;
      }
    }
  }
  .block:nth-child(2n + 1) {
    margin-left: 0px;
  }
}
</style>
